import { render } from "./CentralInquiry.vue?vue&type=template&id=a37a6d96&ts=true"
import script from "./CentralInquiry.ts?vue&type=script&lang=ts&external"
export * from "./CentralInquiry.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__